import React from "react";
import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "./theme";

import "./index.scss";
import classes from "../../utils/classes";

const Code = ({ source, language, full }) => {
  return (
    <div className={classes("code", full && "full")}>
      <div className="code__inner">
        <Highlight
          {...defaultProps}
          theme={theme}
          code={source}
          language={language}
        >
          {({ className, style, tokens, getLineProps, getTokenProps }) => (
            <pre className={className} style={style}>
              {tokens.map((line, i) => (
                <div {...getLineProps({ line, key: i })}>
                  {line.map((token, key) => (
                    <span {...getTokenProps({ token, key })} />
                  ))}
                </div>
              ))}
            </pre>
          )}
        </Highlight>
      </div>
      <div className="code__language-indicator">{language.toUpperCase()}</div>
    </div>
  );
};

export default Code;
